import { useEffect } from 'react';

/**
 * Warns the user with the browser's native prompt before unloading the tab or
 * refreshing while `when` is true (i.e. there are unsaved changes).
 *
 * Note: this covers tab-close / refresh / external navigation. Blocking in-app
 * React Router navigation would require the data router (`createBrowserRouter` +
 * `useBlocker`), which this app does not use; that remains a follow-up.
 */
export function useUnsavedChangesWarning(when: boolean): void {
  useEffect(() => {
    if (!when) return undefined;
    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      // Required for the prompt to show in some browsers.
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [when]);
}
